export enum TipoEtapaPostVenta {
  // Estados de Postventa
  DEFAULT = '',
  ESTADO_INGRESADO = 'Ingresado',
  ESTADO_EN_REVISION = 'En revisión',
  ESTADO_FINALIZADO = 'Finalizado',
}
